import {URLBuilder} from 'url-builder/url-builder';
import {defineMessages} from 'react-intl';
import {URLBuilderLink} from 'lib/url/url-builder-link';

export class DeletedContent {
    constructor(reason, intl) {
        this.defineMessages = defineMessages({FORUM_RULES_VIOLATION: {id: 'FORUM_RULES_VIOLATION'}}).FORUM_RULES_VIOLATION;

        this.rulesLink = new URLBuilderLink({
            label: intl.formatMessage(defineMessages({ FORUM_RULES: { id: 'FORUM_RULES' } }).FORUM_RULES),
            url: "rules",
            urlBuilder: URLBuilder.defaultURLBuilder,
        });
        this.reason = reason;
    }
}
